
  <button mat-raised-button [matMenuTriggerFor]="menu"  color="primary"  >Data</button>
  <mat-menu #menu="matMenu" xPosition="after"  yPosition="below">
    <button mat-menu-item (click)="clear()">Clear</button>
  </mat-menu>

